export const SEND_PASSWORD_RESET_LINK = 'SEND_PASSWORD_RESET_LINK'
export const SEND_PASSWORD_RESET_LINK_FAILED = 'SEND_PASSWORD_RESET_LINK_FAILED'
export const SEND_PASSWORD_RESET_LINK_SUCCEEDED = 'SEND_PASSWORD_RESET_LINK_SUCCEEDED'

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED'
export const CHANGE_PASSWORD_SUCCEEDED = 'CHANGE_PASSWORD_SUCCEEDED'

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const UPDATE_PASSWORD_FAILED = 'UPDATE_PASSWORD_FAILED'
export const UPDATE_PASSWORD_SUCCEEDED = 'UPDATE_PASSWORD_SUCCEEDED'
export const CLEAR_UPDATE_PASSWORD_ERROR = 'CLEAR_UPDATE_PASSWORD_ERROR'
